import React, { useContext, useState } from "react";
import { Videocam, PersonAddAlt1, MoreHoriz } from "@mui/icons-material";
import Messages from "../message/Messages";
import Input from "../message/Input";
import { ChatContext } from "../../context/ChatContext";

export default function Chat({ members }) {
  const { data } = useContext(ChatContext);
  return (
    <div className="chat">
      {data.chatId === "null" ? (
        <h1 className="chatInfo">Select a user to chat</h1>
      ) : (
        <>
          <div className="chatInfo">
            <span>{data.user?.displayName}</span>
          </div>
          <Messages />
          <Input members={members} />
        </>
      )}
    </div>
  );
}
